import styled from 'styled-components';

const BasicDivFlexBothCentered = styled.div`
  display: flex;
  align-items: center;
  justify-content: center;
  flex-wrap: wrap;
  padding: 20px;
`;

export default BasicDivFlexBothCentered;
